// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  ////ScopeFitness
  // appUrl:"https://scopefitness.scopewebstore.com:5241",
  // rootPath:"https://scopefitness.scopewebstore.com:5242",

    // ////WHTest
    // appUrl:"https://whtest.scopewebstore.com:8006",
    // rootPath:"https://whtest.scopewebstore.com:8006",

    ////WH LIVE
    // appUrl:"https://whgym.scopewebstore.com:1957",
    // rootPath:"https://whgym.scopewebstore.com:1957",
   
    appUrl:"https://whgymapi.sentinelscope.com",
    rootPath:"https://whgym.sentinelscope.com",
        

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
